var PHONE_NUMBER_PATTERN = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[\d-\s]{1,14}$/;

var EMAIL_PATTERN = /^[a-zA-Z0-9~!#$%^&*+\-*/=?'"`._{}|]+@[a-zA-Z0-9\-.]+\.[a-z]{2,}$/;

var NUMBER_PATTERNS = {
  FLOAT: /^[-+]?\d*\.?\d*$/
};

var MULTI_TYPES_URL_PATTERN = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
var DOMAIN_PATTERN = /^(?=[a-zA-Z0-9.-]{1,255}\.)[a-zA-Z0-9][a-zA-Z0-9.-]{0,63}\.[a-zA-Z]{2,63}$/;

export { DOMAIN_PATTERN, EMAIL_PATTERN, MULTI_TYPES_URL_PATTERN, NUMBER_PATTERNS, PHONE_NUMBER_PATTERN };
